<template>
    <div
        class="commentForm input-group"
        ref="floating"
        v-if="showCommentEle"
        :style="floatingStyles"
    >
        <editor
            v-model="comment"
            id="commentInput"
            type="text"
            class="form-control d-flex align-items-center border-0"></editor>
        <!-- <input
            id="commentInput"
            type="text"
            class="form-control"
            placeholder="Write a comment..."
            v-model="comment"
        /> -->
        <span class="input-group-text border-0 d-flex align-items-end" id="comment-btn-wrapper"
            ><button type="button" @click="handleSubmit">
                <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 512.000000 512.000000"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <g
                        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        fill="#000000"
                        stroke="none"
                    >
                        <path
                            d="M2465 5111 c-22 -3 -56 -18 -76 -31 -19 -14 -449 -441 -955 -950
            -725 -729 -925 -936 -945 -975 -33 -68 -33 -178 -1 -251 49 -109 155 -177 277
            -177 137 -1 113 -21 745 609 498 495 569 563 603 569 47 9 91 -8 117 -45 19
            -27 20 -59 22 -1821 l3 -1794 26 -55 c36 -77 80 -124 147 -157 76 -37 181 -39
            258 -5 63 29 126 91 156 157 l23 50 5 1800 c4 1437 8 1805 18 1822 25 45 98
            66 145 42 12 -6 276 -264 587 -574 630 -627 598 -601 735 -599 90 1 159 30
            218 93 56 60 82 127 82 211 0 136 62 65 -968 1097 -664 665 -944 939 -979 958
            -39 21 -66 28 -126 30 -42 2 -95 0 -117 -4z"
                        />
                    </g>
                </svg></button
        ></span>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { autoPlacement, offset, useFloating } from "@floating-ui/vue";

const showCommentEle = ref(false);
const isDisplay = ref(false)
const reference = ref(null);
const floating = ref(null);
const { floatingStyles } = useFloating(reference, floating, {
    middleware: [
        offset(3),
        autoPlacement({
            alignment: "right",
        }),
    ],
});
const comment = ref("");
let graphic = null;
let context = null;

onMounted(() => {
    document.addEventListener(
        "cm:open-add-comment-form",
        handleOpenAddCommentForm
    );

    // document.addEventListener(
    //     "cm:open-comment-form",
    //     handleOpenCommentForm
    // );

    document.addEventListener("cm:hide-comment-float-element", function () {
        showCommentEle.value = false;
    });
});

function handleOpenAddCommentForm(evt) {
    showCommentEle.value = true;
    const { graphicData, contextData } = evt.detail;
    var { x, y } = view.toScreen(graphicData.geometry);
    graphic = graphicData;
    context = contextData;
    const clientX = x;
    const clientY = y;

    reference.value = {
        getBoundingClientRect() {
            return {
                width: 0,
                height: 0,
                x: clientX,
                y: clientY,
                left: clientX,
                right: clientX,
                top: clientY,
                bottom: clientY,
            };
        },
    };
}

function handleOpenCommentForm(evt) {
    showCommentEle.value = true;
    const { graphic } = evt.detail;
    var { x, y } = view.toScreen(graphic.geometry);
    const clientX = x;
    const clientY = y;

    let id = graphic?.attributes?.id

    // axios.get('/comments/' + id).then(response => {
    //     console.log(response.data);
    // })

    reference.value = {
        getBoundingClientRect() {
            return {
                width: 0,
                height: 0,
                x: clientX,
                y: clientY,
                left: clientX,
                right: clientX,
                top: clientY,
                bottom: clientY,
            };
        },
    };
}

function handleSubmit() {
    try {


        Object.assign(graphic.attributes, {
                label: "comment",
                layer: context.layer.id,
                markup_id: savedMarkup.uuid,
            });

        axios
            .post(window.scriptVariables.commentUrl, {
                markup: savedMarkup.uuid,
                content: comment.value,
                attributes: graphic.toJSON(),
                collaborator: window.collaborator_id,
            })
            .then((response) => {
                if (response.status == 201) {
                    const added = new Event("cm:comment_added");
                    document.dispatchEvent(added);

                    // hide float element
                    comment.value = "";
                    showCommentEle.value = false;

                    Object.assign(graphic.attributes, {
                        label: "comment",
                        layer: context.layer.id,
                        markup_id: savedMarkup.uuid,
                        id: response.data.id,
                    });

                    // graphic.popupTemplate = {
                    //     title: "Comment",
                    //     content: response.data.content,
                    // };
                    Object.assign(graphic.attributes, { id: response.data.id });

                    context.layer.add(graphic);
                    context.session.updateMarkupSession(
                        graphic.toJSON(),
                        "Comment"
                    );
                    // window.cm.notyf.success("Comment successfully added");
                }
            })
            .catch((error) => {
                if (error.response.status == 402) {
                    window.cm.notyf.error("You need to be subscribed to create a comment. Go to My Account");
                    return
                }

                window.cm.notyf.error("A comment cannot be added at this time");
            });
    } catch (err) {
        console.error(err);
    }
}
</script>
<style scoped>
.commentForm {
    position: absolute;
    color: white;
    box-sizing: border-box;
    top: 500px;
    right: 300px;
    width: 300px;
}

#commentInput {
    border-top-left-radius: 25px;
}

#comment-btn-wrapper {
    padding: 3px;
    margin: 0;
    border-top-right-radius: 22px;
    border-bottom-right-radius: 22px;
}

#comment-btn-wrapper button {
    border-radius: 100%;
    background-color: #fbd715;
    border: none;
    width: 40px;
    height: 40px;
}

.form-control:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
